function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

var _require = require('@uppy/utils/lib/AbortController'),
    AbortController = _require.AbortController,
    createAbortError = _require.createAbortError;

var delay = require('@uppy/utils/lib/delay');

var MB = 1024 * 1024;
var defaultOptions = {
  limit: 1,
  retryDelays: [0, 1000, 3000, 5000],
  getChunkSize: function getChunkSize(file) {
    return Math.ceil(file.size / 10000);
  },
  onStart: function onStart() {},
  onProgress: function onProgress() {},
  onPartComplete: function onPartComplete() {},
  onSuccess: function onSuccess() {},
  onError: function onError(err) {
    throw err;
  }
};

function ensureInt(value) {
  if (typeof value === 'string') {
    return parseInt(value, 10);
  }

  if (typeof value === 'number') {
    return value;
  }

  throw new TypeError('Expected a number');
}

var _aborted = /*#__PURE__*/_classPrivateFieldLooseKey("aborted");

var _initChunks = /*#__PURE__*/_classPrivateFieldLooseKey("initChunks");

var _createUpload = /*#__PURE__*/_classPrivateFieldLooseKey("createUpload");

var _resumeUpload = /*#__PURE__*/_classPrivateFieldLooseKey("resumeUpload");

var _uploadParts = /*#__PURE__*/_classPrivateFieldLooseKey("uploadParts");

var _retryable = /*#__PURE__*/_classPrivateFieldLooseKey("retryable");

var _prepareUploadParts = /*#__PURE__*/_classPrivateFieldLooseKey("prepareUploadParts");

var _uploadPartRetryable = /*#__PURE__*/_classPrivateFieldLooseKey("uploadPartRetryable");

var _uploadPart = /*#__PURE__*/_classPrivateFieldLooseKey("uploadPart");

var _onPartProgress = /*#__PURE__*/_classPrivateFieldLooseKey("onPartProgress");

var _onPartComplete = /*#__PURE__*/_classPrivateFieldLooseKey("onPartComplete");

var _uploadPartBytes = /*#__PURE__*/_classPrivateFieldLooseKey("uploadPartBytes");

var _completeUpload = /*#__PURE__*/_classPrivateFieldLooseKey("completeUpload");

var _abortUpload = /*#__PURE__*/_classPrivateFieldLooseKey("abortUpload");

var _onError = /*#__PURE__*/_classPrivateFieldLooseKey("onError");

var MultipartUploader = /*#__PURE__*/function () {
  function MultipartUploader(file, options) {
    _classCallCheck(this, MultipartUploader);

    Object.defineProperty(this, _onError, {
      value: _onError2
    });
    Object.defineProperty(this, _abortUpload, {
      value: _abortUpload2
    });
    Object.defineProperty(this, _completeUpload, {
      value: _completeUpload2
    });
    Object.defineProperty(this, _uploadPartBytes, {
      value: _uploadPartBytes2
    });
    Object.defineProperty(this, _onPartComplete, {
      value: _onPartComplete2
    });
    Object.defineProperty(this, _onPartProgress, {
      value: _onPartProgress2
    });
    Object.defineProperty(this, _uploadPart, {
      value: _uploadPart2
    });
    Object.defineProperty(this, _uploadPartRetryable, {
      value: _uploadPartRetryable2
    });
    Object.defineProperty(this, _prepareUploadParts, {
      value: _prepareUploadParts2
    });
    Object.defineProperty(this, _retryable, {
      value: _retryable2
    });
    Object.defineProperty(this, _uploadParts, {
      value: _uploadParts2
    });
    Object.defineProperty(this, _resumeUpload, {
      value: _resumeUpload2
    });
    Object.defineProperty(this, _createUpload, {
      value: _createUpload2
    });
    Object.defineProperty(this, _initChunks, {
      value: _initChunks2
    });
    Object.defineProperty(this, _aborted, {
      value: _aborted2
    });
    this.options = _objectSpread(_objectSpread({}, defaultOptions), options); // Use default `getChunkSize` if it was null or something

    if (!this.options.getChunkSize) {
      this.options.getChunkSize = defaultOptions.getChunkSize;
    }

    this.file = file;
    this.abortController = new AbortController();
    this.key = this.options.key || null;
    this.uploadId = this.options.uploadId || null;
    this.parts = []; // Do `this.createdPromise.then(OP)` to execute an operation `OP` _only_ if the
    // upload was created already. That also ensures that the sequencing is right
    // (so the `OP` definitely happens if the upload is created).
    //
    // This mostly exists to make `#abortUpload` work well: only sending the abort request if
    // the upload was already created, and if the createMultipartUpload request is still in flight,
    // aborting it immediately after it finishes.

    this.createdPromise = Promise.reject(); // eslint-disable-line prefer-promise-reject-errors

    this.isPaused = false;
    this.partsInProgress = 0;
    this.chunks = null;
    this.chunkState = null;

    _classPrivateFieldLooseBase(this, _initChunks)[_initChunks]();

    this.createdPromise.catch(function () {}); // silence uncaught rejection warning
  }
  /**
   * Was this upload aborted?
   *
   * If yes, we may need to throw an AbortError.
   *
   * @returns {boolean}
   */


  _createClass(MultipartUploader, [{
    key: "start",
    value: function start() {
      this.isPaused = false;

      if (this.uploadId) {
        _classPrivateFieldLooseBase(this, _resumeUpload)[_resumeUpload]();
      } else {
        _classPrivateFieldLooseBase(this, _createUpload)[_createUpload]();
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      this.abortController.abort(); // Swap it out for a new controller, because this instance may be resumed later.

      this.abortController = new AbortController();
      this.isPaused = true;
    }
  }, {
    key: "abort",
    value: function abort(opts) {
      var _opts;

      if (opts === void 0) {
        opts = undefined;
      }

      if ((_opts = opts) != null && _opts.really) _classPrivateFieldLooseBase(this, _abortUpload)[_abortUpload]();else this.pause();
    }
  }]);

  return MultipartUploader;
}();

function _aborted2() {
  return this.abortController.signal.aborted;
}

function _initChunks2() {
  var chunks = [];
  var desiredChunkSize = this.options.getChunkSize(this.file); // at least 5MB per request, at most 10k requests

  var minChunkSize = Math.max(5 * MB, Math.ceil(this.file.size / 10000));
  var chunkSize = Math.max(desiredChunkSize, minChunkSize); // Upload zero-sized files in one zero-sized chunk

  if (this.file.size === 0) {
    chunks.push(this.file);
  } else {
    for (var i = 0; i < this.file.size; i += chunkSize) {
      var end = Math.min(this.file.size, i + chunkSize);
      chunks.push(this.file.slice(i, end));
    }
  }

  this.chunks = chunks;
  this.chunkState = chunks.map(function () {
    return {
      uploaded: 0,
      busy: false,
      done: false
    };
  });
}

function _createUpload2() {
  var _this = this;

  this.createdPromise = Promise.resolve().then(function () {
    return _this.options.createMultipartUpload();
  });
  return this.createdPromise.then(function (result) {
    if (_classPrivateFieldLooseBase(_this, _aborted)[_aborted]()) throw createAbortError();
    var valid = _typeof(result) === 'object' && result && typeof result.uploadId === 'string' && typeof result.key === 'string';

    if (!valid) {
      throw new TypeError('AwsS3/Multipart: Got incorrect result from `createMultipartUpload()`, expected an object `{ uploadId, key }`.');
    }

    _this.key = result.key;
    _this.uploadId = result.uploadId;

    _this.options.onStart(result);

    _classPrivateFieldLooseBase(_this, _uploadParts)[_uploadParts]();
  }).catch(function (err) {
    _classPrivateFieldLooseBase(_this, _onError)[_onError](err);
  });
}

function _resumeUpload2() {
  return _resumeUpload3.apply(this, arguments);
}

function _resumeUpload3() {
  _resumeUpload3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _this7 = this;

    var parts;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return this.options.listParts({
              uploadId: this.uploadId,
              key: this.key
            });

          case 3:
            parts = _context.sent;

            if (!_classPrivateFieldLooseBase(this, _aborted)[_aborted]()) {
              _context.next = 6;
              break;
            }

            throw createAbortError();

          case 6:
            parts.forEach(function (part) {
              var i = part.PartNumber - 1;
              _this7.chunkState[i] = {
                uploaded: ensureInt(part.Size),
                etag: part.ETag,
                done: true
              }; // Only add if we did not yet know about this part.

              if (!_this7.parts.some(function (p) {
                return p.PartNumber === part.PartNumber;
              })) {
                _this7.parts.push({
                  PartNumber: part.PartNumber,
                  ETag: part.ETag
                });
              }
            });

            _classPrivateFieldLooseBase(this, _uploadParts)[_uploadParts]();

            _context.next = 13;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);

            _classPrivateFieldLooseBase(this, _onError)[_onError](_context.t0);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 10]]);
  }));
  return _resumeUpload3.apply(this, arguments);
}

function _uploadParts2() {
  var _this2 = this;

  if (this.isPaused) return; // All parts are uploaded.

  if (this.chunkState.every(function (state) {
    return state.done;
  })) {
    _classPrivateFieldLooseBase(this, _completeUpload)[_completeUpload]();

    return;
  } // For a 100MB file, with the default min chunk size of 5MB and a limit of 10:
  //
  // Total 20 parts
  // ---------
  // Need 1 is 10
  // Need 2 is 5
  // Need 3 is 5


  var need = this.options.limit - this.partsInProgress;
  var completeChunks = this.chunkState.filter(function (state) {
    return state.done;
  }).length;
  var remainingChunks = this.chunks.length - completeChunks;
  var minNeeded = Math.ceil(this.options.limit / 2);

  if (minNeeded > remainingChunks) {
    minNeeded = remainingChunks;
  }

  if (need < minNeeded) return;
  var candidates = [];

  for (var i = 0; i < this.chunkState.length; i++) {
    var state = this.chunkState[i]; // eslint-disable-next-line no-continue

    if (state.done || state.busy) continue;
    candidates.push(i);

    if (candidates.length >= need) {
      break;
    }
  }

  if (candidates.length === 0) return;

  _classPrivateFieldLooseBase(this, _prepareUploadParts)[_prepareUploadParts](candidates).then(function (result) {
    candidates.forEach(function (index) {
      var partNumber = index + 1;
      var prePreparedPart = {
        url: result.presignedUrls[partNumber],
        headers: result.headers
      };

      _classPrivateFieldLooseBase(_this2, _uploadPartRetryable)[_uploadPartRetryable](index, prePreparedPart).then(function () {
        _classPrivateFieldLooseBase(_this2, _uploadParts)[_uploadParts]();
      }, function (err) {
        _classPrivateFieldLooseBase(_this2, _onError)[_onError](err);
      });
    });
  });
}

function _retryable2(_ref) {
  var _this3 = this;

  var before = _ref.before,
      attempt = _ref.attempt,
      after = _ref.after;
  var retryDelays = this.options.retryDelays;
  var signal = this.abortController.signal;
  if (before) before();

  function shouldRetry(err) {
    if (err.source && typeof err.source.status === 'number') {
      var status = err.source.status; // 0 probably indicates network failure

      return status === 0 || status === 409 || status === 423 || status >= 500 && status < 600;
    }

    return false;
  }

  var doAttempt = function doAttempt(retryAttempt) {
    return attempt().catch(function (err) {
      if (_classPrivateFieldLooseBase(_this3, _aborted)[_aborted]()) throw createAbortError();

      if (shouldRetry(err) && retryAttempt < retryDelays.length) {
        return delay(retryDelays[retryAttempt], {
          signal: signal
        }).then(function () {
          return doAttempt(retryAttempt + 1);
        });
      }

      throw err;
    });
  };

  return doAttempt(0).then(function (result) {
    if (after) after();
    return result;
  }, function (err) {
    if (after) after();
    throw err;
  });
}

function _prepareUploadParts2(_x) {
  return _prepareUploadParts3.apply(this, arguments);
}

function _prepareUploadParts3() {
  _prepareUploadParts3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(candidates) {
    var _this8 = this;

    var result;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            candidates.forEach(function (i) {
              _this8.chunkState[i].busy = true;
            });
            _context2.next = 3;
            return _classPrivateFieldLooseBase(this, _retryable)[_retryable]({
              attempt: function attempt() {
                return _this8.options.prepareUploadParts({
                  key: _this8.key,
                  uploadId: _this8.uploadId,
                  partNumbers: candidates.map(function (index) {
                    return index + 1;
                  }),
                  chunks: candidates.reduce(function (chunks, candidate) {
                    return _objectSpread(_objectSpread({}, chunks), {}, _defineProperty({}, candidate + 1, _this8.chunks[candidate]));
                  }, {})
                });
              }
            });

          case 3:
            result = _context2.sent;

            if (!(_typeof(result == null ? void 0 : result.presignedUrls) !== 'object')) {
              _context2.next = 6;
              break;
            }

            throw new TypeError('AwsS3/Multipart: Got incorrect result from `prepareUploadParts()`, expected an object `{ presignedUrls }`.');

          case 6:
            return _context2.abrupt("return", result);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));
  return _prepareUploadParts3.apply(this, arguments);
}

function _uploadPartRetryable2(index, prePreparedPart) {
  var _this4 = this;

  return _classPrivateFieldLooseBase(this, _retryable)[_retryable]({
    before: function before() {
      _this4.partsInProgress += 1;
    },
    attempt: function attempt() {
      return _classPrivateFieldLooseBase(_this4, _uploadPart)[_uploadPart](index, prePreparedPart);
    },
    after: function after() {
      _this4.partsInProgress -= 1;
    }
  });
}

function _uploadPart2(index, prePreparedPart) {
  this.chunkState[index].busy = true;
  var valid = typeof (prePreparedPart == null ? void 0 : prePreparedPart.url) === 'string';

  if (!valid) {
    throw new TypeError('AwsS3/Multipart: Got incorrect result for `prePreparedPart`, expected an object `{ url }`.');
  }

  var url = prePreparedPart.url,
      headers = prePreparedPart.headers;

  if (_classPrivateFieldLooseBase(this, _aborted)[_aborted]()) {
    this.chunkState[index].busy = false;
    throw createAbortError();
  }

  return _classPrivateFieldLooseBase(this, _uploadPartBytes)[_uploadPartBytes](index, url, headers);
}

function _onPartProgress2(index, sent) {
  this.chunkState[index].uploaded = ensureInt(sent);
  var totalUploaded = this.chunkState.reduce(function (n, c) {
    return n + c.uploaded;
  }, 0);
  this.options.onProgress(totalUploaded, this.file.size);
}

function _onPartComplete2(index, etag) {
  this.chunkState[index].etag = etag;
  this.chunkState[index].done = true;
  var part = {
    PartNumber: index + 1,
    ETag: etag
  };
  this.parts.push(part);
  this.options.onPartComplete(part);
}

function _uploadPartBytes2(index, url, headers) {
  var _this5 = this;

  var body = this.chunks[index];
  var signal = this.abortController.signal;
  var defer;
  var promise = new Promise(function (resolve, reject) {
    defer = {
      resolve: resolve,
      reject: reject
    };
  });
  var xhr = new XMLHttpRequest();
  xhr.open('PUT', url, true);

  if (headers) {
    Object.keys(headers).forEach(function (key) {
      xhr.setRequestHeader(key, headers[key]);
    });
  }

  xhr.responseType = 'text';

  function cleanup() {
    // eslint-disable-next-line no-use-before-define
    signal.removeEventListener('abort', onabort);
  }

  function onabort() {
    xhr.abort();
  }

  signal.addEventListener('abort', onabort);
  xhr.upload.addEventListener('progress', function (ev) {
    if (!ev.lengthComputable) return;

    _classPrivateFieldLooseBase(_this5, _onPartProgress)[_onPartProgress](index, ev.loaded, ev.total);
  });
  xhr.addEventListener('abort', function () {
    cleanup();
    _this5.chunkState[index].busy = false;
    defer.reject(createAbortError());
  });
  xhr.addEventListener('load', function (ev) {
    cleanup();
    _this5.chunkState[index].busy = false;

    if (ev.target.status < 200 || ev.target.status >= 300) {
      var error = new Error('Non 2xx');
      error.source = ev.target;
      defer.reject(error);
      return;
    } // This avoids the net::ERR_OUT_OF_MEMORY in Chromium Browsers.


    _this5.chunks[index] = null;

    _classPrivateFieldLooseBase(_this5, _onPartProgress)[_onPartProgress](index, body.size, body.size); // NOTE This must be allowed by CORS.


    var etag = ev.target.getResponseHeader('ETag');

    if (etag === null) {
      defer.reject(new Error('AwsS3/Multipart: Could not read the ETag header. This likely means CORS is not configured correctly on the S3 Bucket. See https://uppy.io/docs/aws-s3-multipart#S3-Bucket-Configuration for instructions.'));
      return;
    }

    _classPrivateFieldLooseBase(_this5, _onPartComplete)[_onPartComplete](index, etag);

    defer.resolve();
  });
  xhr.addEventListener('error', function (ev) {
    cleanup();
    _this5.chunkState[index].busy = false;
    var error = new Error('Unknown error');
    error.source = ev.target;
    defer.reject(error);
  });
  xhr.send(body);
  return promise;
}

function _completeUpload2() {
  return _completeUpload3.apply(this, arguments);
}

function _completeUpload3() {
  _completeUpload3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    var result;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            // Parts may not have completed uploading in sorted order, if limit > 1.
            this.parts.sort(function (a, b) {
              return a.PartNumber - b.PartNumber;
            });
            _context3.prev = 1;
            _context3.next = 4;
            return this.options.completeMultipartUpload({
              key: this.key,
              uploadId: this.uploadId,
              parts: this.parts
            });

          case 4:
            result = _context3.sent;
            this.options.onSuccess(result);
            _context3.next = 11;
            break;

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](1);

            _classPrivateFieldLooseBase(this, _onError)[_onError](_context3.t0);

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this, [[1, 8]]);
  }));
  return _completeUpload3.apply(this, arguments);
}

function _abortUpload2() {
  var _this6 = this;

  this.abortController.abort();
  this.createdPromise.then(function () {
    _this6.options.abortMultipartUpload({
      key: _this6.key,
      uploadId: _this6.uploadId
    });
  }, function () {// if the creation failed we do not need to abort
  });
}

function _onError2(err) {
  if (err && err.name === 'AbortError') {
    return;
  }

  this.options.onError(err);
}

module.exports = MultipartUploader;